import { format } from 'date-fns';

const formatTime = (date: Date) => format(date, 'HH:mm');

export default formatTime;
